<template>
  <div>
    <!-- 我的休假 -->
    <div class="box-margin">
      <Card>
        <Form
          :model="formItem"
          :label-width="110"
          label-position="left"
          :disabled="prevent"
        >
          <Row style="margin-bottom: 0">
            <Col span="5">
              <FormItem label="休假类别：">
                <Select
                  :clearable="true"
                  v-model="formItem.leavetype"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in CJBList"
                    :key="index"
                    :value="item.code"
                    >{{ item.otcname }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5" offset="1">
              <FormItem label="缺勤别">
                <Select
                  :clearable="true"
                  v-model="formItem.qqtype"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in QQBList"
                    :key="index"
                    :value="item.code"
                    >{{ item.atcname }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5" offset="1">
              <FormItem label="申请单状态：">
                <Select
                  :clearable="true"
                  v-model="formItem.status_nm"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in SQDList"
                    :key="index"
                    :value="item.code"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="6" offset="1">
              <FormItem label="起始日：">
                <Date-picker
                  style="width: 100%"
                  format="yyyy/MM/dd"
                  type="daterange"
                  v-model="formItem.start_date"
                  placeholder="请选择日期"
                  :editable="false"
                />
              </FormItem>
            </Col>
          </Row>
          <Row style="margin-bottom: 0">
            <Col span="7">
              <FormItem label="申请单号：">
                <Input v-model="formItem.order_no" />
              </FormItem>
            </Col>
            <!-- <Col span="1" offset="1">
              <Button
                type="primary"
                @click="
                  (pageInfo1.pageNo = 1),
                    (pageInfo1.itemCount = 0),
                    (pageInfo2.pageNo = 1),
                    (pageInfo2.itemCount = 0),
                    getMX()
                "
                >明细</Button
              >
            </Col>
            <Col span="1" offset="1">
              <Button
                type="primary"
                @click="
                  (pageInfo3.pageNo = 1), (pageInfo3.itemCount = 0), getTJ()
                "
                >统计</Button
              >
            </Col> -->
          </Row>
        </Form>
      </Card>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">缺勤明细信息</p>
        <Table
          border
          :columns="columns1"
          :data="data1"
          :loading="modal_loading"
        >
        </Table>
        <Page
          style="display: flex; justify-content: flex-end; margin-top: 20px"
          :total="pageInfo1.itemCount"
          @on-change="pageChange1"
        />
      </Card>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">休假申请明细信息</p>
        <Table
          border
          :columns="columns3"
          :data="data3"
          :loading="modal_loading"
        >
        </Table>
        <Page
          style="display: flex; justify-content: flex-end; margin-top: 20px"
          :total="pageInfo2.itemCount"
          @on-change="pageChange2"
        />
      </Card>
    </div>
    <div class="box-margin">
      <Card>
        <p slot="title">实际休假明细信息</p>
        <Table
          border
          :columns="columns4"
          :data="data4"
          :loading="modal_loading"
        >
        </Table>
        <Page
          style="display: flex; justify-content: flex-end; margin-top: 20px"
          :total="pageInfo4.itemCount"
          @on-change="pageChange4"
        />
      </Card>
    </div>

    <!-- 选择人员对话框 -->
    <div class="consumForm">
      <Modal :title="titleText" v-model="config" width="80%">
        <Form
          :model="formItem"
          :label-width="70"
          :disabled="modal_loading"
          label-position="left"
        >
          <Row>
            <Col span="4">
              <FormItem label="share.personnelCode')">
                <Input v-model="filter.emp_code" placeholder=""> </Input>
              </FormItem>
            </Col>
            <Col span="4" offset="1">
              <FormItem label="share.name')">
                <Input v-model="filter.user_name" placeholder=""></Input>
              </FormItem>
            </Col>
            <Col span="4" offset="1">
              <FormItem label="share.company')">
                <Input v-model="filter.orgsname2" placeholder=""></Input>
              </FormItem>
            </Col>
            <Col span="4" offset="1">
              <FormItem label="share.district')">
                <Input v-model="filter.orgsname4" placeholder=""></Input>
              </FormItem>
            </Col>
            <Col span="4" offset="1">
              <Button
                type="primary"
                style="margin-left: 8px"
                @click="(pageInfo.pageNo = 1), (totalNum = 0), filterFunction()"
                >{{ $t("query") }}</Button
              >
            </Col>
          </Row>
        </Form>
        <Table
          border
          :columns="columns2"
          :data="data2"
          :loading="modal_loading"
        >
          <template slot-scope="{ row }" slot="action">
            <Icon
              type="md-checkmark"
              :style="{ color: 'blue' }"
              @click="show(row)"
            />
          </template>
        </Table>
        <div slot="footer">
          <Page
            v-if="data2.length > 0"
            :total="this.totalNum"
            @on-change="pageChange"
          />
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import DateUtil from "../../../util/DateUtil";
import ModelUtils from "../../../util/ModelUtil";
import axios from "axios";
export default {
  data() {
    return {
      CJBList: [],
      pageInfo1: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      pageInfo2: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      pageInfo3: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      pageInfo4: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      SQDList: [
        {
          code: "0",
          name: "申请中"
        },
        {
          code: "8",
          name: "申请通过"
        }
      ],
      formItem: {},
      filter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      totalNum: 0,
      prevent: false,
      modal_loading: false,
      config: false,
      titleText: this.$t("share.selectPeople"),
      date: new DateUtil(),
      columns1: [
        // {
        //   title: "员工工号",
        //   key: "emp_code",
        //   width: 120,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "姓名",
        //   key: "user_name",
        //   width: 120,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "公司",
        //   key: "orgsname2",
        //   width: 120,
        //   align: "center",
        // },
        // {
        //   title: "地区",
        //   key: "orgsname4",
        //   width: 120,
        //   align: "center",
        // },
        // {
        //   title: "职位",
        //   key: "position_name",
        //   width: 160,
        //   align: "center",
        // },
        {
          title: "缺勤别",
          key: "leavename",
          // width: 140,
          align: "center"
        },
        {
          title: "日期",
          // width: 150,
          align: "center",
          sortable: true,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begintime, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "次数",
          key: "leavecs",
          // width: 130,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.leavecs ? params.row.leavecs : "-");
          }
        },
        {
          title: "请假时长",
          key: "leavetime_hh",
          // width: 130,
          align: "center"
        },
        {
          title: "申请单号",
          key: "order_no",
          // width: 220,
          align: "center"
        },
        {
          title: "申请单状态",
          key: "status_nm",
          // width: 140,
          align: "center"
        }
      ],
      data1: [
        {
          atsid: 100,
          begintime: "2000/01/14",
          emp_code: "583173",
          endtime: "2000-01-14T08:31:00.000+08:00",
          hrstatus: "L1",
          leavecs: "1",
          leavemi: 8,
          leavename: "迟到",
          leavetime_hh: "13:24",
          leavetype: "AT_L",
          notes: "leave_reason",
          orgsname1: "EVG",
          orgsname2: "EVSSH",
          orgsname3: "",
          orgsname4: "",
          orgsname5: "",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "经理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001890",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          typeid: 4,
          user_name: "周琦"
        },
        {
          atsid: 100,
          begintime: "2000/03/17",
          emp_code: "582233",
          endtime: "2000-03-17T08:31:00.000+08:00",
          hrstatus: "L1",
          leavecs: "1",
          leavemi: 8,
          leavename: "迟到",
          leavetime_hh: "15:30",
          leavetype: "AT_L",
          notes: "leave_reason",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "BCD",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "副理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001907",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          typeid: 4,
          user_name: "应　勇"
        }
      ],
      columns2: [
        {
          title: this.$t("educationalInformation.personnelCode"),
          key: "emp_code"
        },
        {
          title: this.$t("educationalInformation.name"),
          key: "user_name"
        },
        {
          title: this.$t("educationalInformation.company"),
          key: "orgsname2"
        },
        {
          title: this.$t("educationalInformation.district"),
          key: "orgsname4"
        },
        {
          title: this.$t("formalTrialApproval.ministry"),
          key: "orgsname5"
        },
        {
          title: this.$t("educationalInformation.lesson"),
          align: "center",
          key: "orgsname6"
        },
        {
          title: this.$t("OvertimeModificationApply.group"),
          align: "center",
          key: "orgsname7"
        },
        {
          title: this.$t("share.Choice"),
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      data2: [],
      columns3: [
        // {
        //   title: "员工工号",
        //   key: "emp_code",
        //   width: 100,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "姓名",
        //   key: "user_name",
        //   width: 100,
        //   align: "center",
        //   fixed: "left",
        // },
        // {
        //   title: "公司",
        //   key: "orgsname2",
        //   width: 100,
        //   align: "center",
        // },
        // {
        //   title: "地区",
        //   key: "orgsname4",
        //   width: 100,
        //   align: "center",
        // },

        // {
        //   title: "职位",
        //   key: "position_name",
        //   width: 150,
        //   align: "center",
        // },
        {
          title: "休假类别",
          key: "leavename",
          // width: 100,
          align: "center"
        },
        {
          title: "休假起始时间",
          align: "center",
          children: [
            {
              title: "日期",
              key: "begindt",
              // width: "120",
              align: "center",
              sortable: true
            },
            {
              title: "时间",
              key: "begintime",
              // width: "85",
              align: "center",
              render: (h, params) => {
                return h(
                  "span",
                  this.date.dateVal(
                    params.row.begindt + " " + params.row.begintime,
                    "HH:mm"
                  )
                );
              }
            }
          ]
        },
        {
          title: "休假结束时间",
          align: "center",
          children: [
            {
              title: "日期",
              key: "enddt",
              // width: "120",
              align: "center",
              sortable: true
            },
            {
              title: "时间",
              key: "endtime",
              // width: "85",
              align: "center",
              render: (h, params) => {
                return h(
                  "span",
                  this.date.dateVal(
                    params.row.enddt + " " + params.row.endtime,
                    "HH:mm"
                  )
                );
              }
            }
          ]
        },
        {
          title: "日数",
          key: "leavetime_dd",
          // width: 100,
          align: "center"
        },
        {
          title: "小时数",
          key: "leavetime_hh",
          // width: 100,
          align: "center"
        },

        {
          title: "申请单号",
          key: "order_no",
          // width: 220,
          align: "center"
        },
        {
          title: "申请单状态",
          key: "status_nm",
          // width: 105,
          align: "center"
        }
      ],
      data3: [
        {
          atsid: 100,
          attachment_type: "",
          emp_code: "990889",
          fujianmingcheng: "",
          hrstatus: "L1",
          is_late: "Y",
          leavetime: 0,
          order_no: "LM-ECNSHG202203020001",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "HRD",
          orgsname6: "000",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "副课长",
          processid: "ca4d27c5-9a09-11ec-9178-f48e38dcf5de",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000002356",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "0",
          status_nm: "申请中",
          super_sure: "",
          typeid: 0,
          user_name: "黄佳莹",
          begintimes: "1998-01-16T08:30:00.000+08:00",
          endtimes: "1998-01-16T10:30:00.000+08:00"
        },
        {
          atsid: 100,
          begindt: "1998/01/16",
          begintime: "08:30:00",
          begintimes: "1998-01-16T08:30:00.000+08:00",
          emp_code: "582233",
          enddt: "1998/01/16",
          endtime: "10:30:00",
          endtimes: "1998-01-16T10:30:00.000+08:00",
          hrstatus: "L1",
          is_late: "",
          leavename: "事假",
          leavetime: 2,
          leavetime_dd: 0,
          leavetime_hh: 2,
          leavetype: "A",
          notes: "leave_reason",
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "BCD",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "副理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001907",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          super_sure: "",
          typeid: 4,
          user_name: "应勇"
        },
        {
          atsid: 100,
          begindt: "1998/01/07",
          begintime: "08:30:00",
          begintimes: "1998-01-07T08:30:00.000+08:00",
          emp_code: "575720",
          enddt: "1998/01/07",
          endtime: "12:00:00",
          endtimes: "1998-01-07T12:00:00.000+08:00",
          hrstatus: "L1",
          is_late: "",
          leavename: "特別休假",
          leavetime: 4,
          leavetime_dd: 0,
          leavetime_hh: 4,
          leavetype: "0",
          notes: "leave_reason",
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "CSD",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "经理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001096",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          super_sure: "",
          typeid: 0,
          user_name: "刘英名"
        }
      ],
      columns4: [
        {
          title: "休假类别",
          key: "leavename",
          // width: 100,
          align: "center"
        },
        {
          title: "休假起始时间",
          align: "center",
          children: [
            {
              title: "日期",
              key: "begindt",
              // width: "120",
              align: "center",
              sortable: true
            },
            {
              title: "时间",
              key: "begintime",
              // width: "85",
              align: "center",
              render: (h, params) => {
                return h(
                  "span",
                  this.date.dateVal(
                    params.row.begindt + " " + params.row.begintime,
                    "HH:mm"
                  )
                );
              }
            }
          ]
        },
        {
          title: "休假结束时间",
          align: "center",
          children: [
            {
              title: "日期",
              key: "enddt",
              // width: "120",
              align: "center",
              sortable: true
            },
            {
              title: "时间",
              key: "endtime",
              // width: "85",
              align: "center",
              render: (h, params) => {
                return h(
                  "span",
                  this.date.dateVal(
                    params.row.enddt + " " + params.row.endtime,
                    "HH:mm"
                  )
                );
              }
            }
          ]
        },
        {
          title: "日数",
          key: "leavetime_dd",
          // width: 100,
          align: "center"
        },
        {
          title: "小时数",
          key: "leavetime_hh",
          // width: 100,
          align: "center"
        }
      ],
      data4: [
        {
          atsid: 100,
          attachment_type: "",
          emp_code: "990889",
          fujianmingcheng: "",
          hrstatus: "L1",
          is_late: "Y",
          leavetime: 0,
          order_no: "LM-ECNSHG202203020001",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "HRD",
          orgsname6: "000",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "副课长",
          processid: "ca4d27c5-9a09-11ec-9178-f48e38dcf5de",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000002356",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "0",
          status_nm: "申请中",
          super_sure: "",
          typeid: 0,
          user_name: "黄佳莹",
          begintimes: "1998-01-16T08:30:00.000+08:00",
          endtimes: "1998-01-16T10:30:00.000+08:00"
        },
        {
          atsid: 100,
          begindt: "1998/01/16",
          begintime: "08:30:00",
          begintimes: "1998-01-16T08:30:00.000+08:00",
          emp_code: "582233",
          enddt: "1998/01/16",
          endtime: "10:30:00",
          endtimes: "1998-01-16T10:30:00.000+08:00",
          hrstatus: "L1",
          is_late: "",
          leavename: "事假",
          leavetime: 2,
          leavetime_dd: 0,
          leavetime_hh: 2,
          leavetype: "A",
          notes: "leave_reason",
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "BCD",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "副理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001907",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          super_sure: "",
          typeid: 4,
          user_name: "应勇"
        },
        {
          atsid: 100,
          begindt: "1998/01/07",
          begintime: "08:30:00",
          begintimes: "1998-01-07T08:30:00.000+08:00",
          emp_code: "575720",
          enddt: "1998/01/07",
          endtime: "12:00:00",
          endtimes: "1998-01-07T12:00:00.000+08:00",
          hrstatus: "L1",
          is_late: "",
          leavename: "特別休假",
          leavetime: 4,
          leavetime_dd: 0,
          leavetime_hh: 4,
          leavetype: "0",
          notes: "leave_reason",
          order_no: "",
          orgsname1: "EVG",
          orgsname2: "ECN",
          orgsname3: "CCN",
          orgsname4: "SHG",
          orgsname5: "CSD",
          orgsname6: "",
          orgsname7: "",
          orgsname8: "",
          orgsname9: "",
          orgsname10: "",
          position_name: "经理",
          processid: "",
          rszt: "当地员工(试用/正式)",
          serialnumber: "0000001096",
          shijijieshuri: "1900-01-01T00:00:00.000+08:00",
          status: "8",
          status_nm: "",
          super_sure: "",
          typeid: 0,
          user_name: "刘英名"
        }
      ],
      JBList: [],
      QQBList: [],
      rsztList: []
    };
  },
  watch: {},
  mounted() {
    // this.getMX();
    this.formItem.emp_code = JSON.parse(
      window.sessionStorage.getItem("userInfo")
    ).loginUserId;
  },
  updated() {
    this.empty();
  },
  methods: {
    pageChange1() {},
    pageChange2() {},
    pageChange4() {}
  }
};
</script>
<style scoped>
.box-margin {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/MyLeave.vue